import { IProjectMemberRepository } from "domain/contracts/project-member.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { ProjectMember } from "domain/entities/project-member";
import { ProjectMemberInputFilter } from "domain/models/project-member-input-filter";
import { formatDate } from "presentation/utils/formatEndDate";

class ProjectMemberRepository implements IProjectMemberRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/projectMember/${id}`);
    return response.data;
  }

  async create(input: ProjectMember): Promise<Message<ProjectMember>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };

    const response = await httpClient.post(`/projectMember`, { data: newInput });
    return response.data;
  }

  async update(input: ProjectMember): Promise<Message<boolean>> {
    let endAt = formatDate(input.endAt);
    let startAt = formatDate(input.startAt);
    let newInput: any = { ...input, endAt: endAt, startAt: startAt };

    const response = await httpClient.put(`/projectMember/${input.id}`, {
      data: newInput,
    });
    return response.data;
  }

  async getAll(filter: ProjectMemberInputFilter): Promise<Message<ProjectMember[]>> {
    const response = await httpClient.get(`/projectMember`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<ProjectMember>> {
    const response = await httpClient.get(`/projectMember/${id}`);
    return response.data;
  }
}

export default new ProjectMemberRepository();
